<div class="welcome-container d-flex flex-column align-items-center w-100">
  <!-- Success Header -->
  @if (showSuccess()) {
    <div class="success-header text-center w-100" role="status" aria-live="polite">
      <div class="success-icon-wrap d-flex justify-content-center mb-2">
        <i class="fas fa-check-circle success-check-icon" aria-hidden="true"></i>
      </div>
      <h1 class="welcome-title mt-4">Welcome to ActivityPro,</h1>
      <h2 class="club-name fw-bold">{{ clubName() }}</h2>
    </div>
  }

  <!-- Instructions -->
  @if (showInstructions()) {
    <div class="form-container w-100 mx-auto" [class.slide-up]="showInstructions()">
      <div class="form-card">

        <!-- Login Credentials Summary -->
        @if (adminEmail()) {
          <div class="credentials-section mb-4">
            <h3 class="fw-bold mb-3">Your Login Credentials</h3>
            <p class="text-secondary mb-3" style="font-size: 14px;">Login credentials have been sent to the email addresses below. Check your inbox to get started.</p>

            <div class="credential-card mb-3">
              <div class="credential-header">
                <i class="fas fa-user-shield" aria-hidden="true"></i>
                <span>Admin Account</span>
              </div>
              <div class="credential-body">
                <div class="credential-row">
                  <span class="credential-label">Email</span>
                  <span class="credential-value">{{ adminEmail() }}</span>
                  <button class="copy-btn" (click)="copyToClipboard(adminEmail())" title="Copy email" aria-label="Copy admin email">
                    <i class="fas fa-copy" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>

            @if (coachEmail()) {
              <div class="credential-card">
                <div class="credential-header coach">
                  <i class="fas fa-user-graduate" aria-hidden="true"></i>
                  <span>Coach Account — {{ coachName() }}</span>
                </div>
                <div class="credential-body">
                  <div class="credential-row">
                    <span class="credential-label">Email</span>
                    <span class="credential-value">{{ coachEmail() }}</span>
                    <button class="copy-btn" (click)="copyToClipboard(coachEmail())" title="Copy email" aria-label="Copy coach email">
                      <i class="fas fa-copy" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <h3 class="fw-bold mb-4">Let's Get You Started!</h3>
        <section class="steps">
          <h4 class="fw-bold mt-4 mb-3">Club Admin App</h4>
          <ul class="list-group" role="list">
            @for (step of adminAppsteps; track step) {
              <li class="list-group-item" role="listitem">
                <div class="d-flex align-items-center">
                  <div class="step-icon d-flex justify-content-center align-items-center">
                    <i [class]="step.icon" aria-hidden="true"></i>
                  </div>
                  {{ step.title }}
                </div>
                @if (step.content === 'admin-app-links') {
                  <div class="d-flex align-items-center gap-3 mt-3 content-alignment">
                    <app-button label="Get it on Google Play" variant="filled" color="primary" icon="fab fa-google-play" [fullWidth]="false"
                      (clicked)="openUrl('https://play.google.com/store/apps/details?id=app.activitypro.apadminnextgen')">
                    </app-button>
                    <app-button label="Download on the App Store" variant="outline" color="primary" icon="fab fa-apple" [fullWidth]="false"
                      (clicked)="openUrl('https://apps.apple.com/in/app/activitypro-admin/id6499510617')">
                    </app-button>
                  </div>
                }
              </li>
            }
          </ul>

          <h4 class="fw-bold mt-4 mb-3">Club Member App</h4>
          <ul class="list-group" role="list">
            @for (step of memberAppsteps; track step) {
              <li class="list-group-item" role="listitem">
                <div class="d-flex align-items-center">
                  <div class="step-icon d-flex justify-content-center align-items-center">
                    <i [class]="step.icon" aria-hidden="true"></i>
                  </div>
                  {{ step.title }}
                </div>
                @if (step.content === 'shareable-app-links') {
                  <div class="d-flex mt-3 content-alignment">
                    <app-button label="Share Via Email" variant="filled" color="primary" icon="fas fa-share-alt" [fullWidth]="false"
                      (clicked)="openUrl('mailto:?subject=' + emailDetails().subject + '&body=' + emailDetails().body)">
                    </app-button>
                  </div>
                }
                @if (step.content === 'member-app-links') {
                  <div class="d-flex align-items-center gap-3 mt-3 content-alignment">
                    <app-button label="Get it on Google Play" variant="filled" color="primary" icon="fab fa-google-play" [fullWidth]="false"
                      (clicked)="openUrl('https://play.google.com/store/apps/details?id=app.activitypro.activitybuddy')">
                    </app-button>
                    <app-button label="Download on the App Store" variant="outline" color="primary" icon="fab fa-apple" [fullWidth]="false"
                      (clicked)="openUrl('https://apps.apple.com/in/app/activitybuddy/id6612029343')">
                    </app-button>
                  </div>
                }
              </li>
            }
          </ul>
        </section>

        <!-- Go to Login -->
        <div class="login-cta mt-5 text-center">
          <app-button label="Go to Login" variant="filled" color="primary" icon="fas fa-sign-in-alt" [fullWidth]="true"
            class="w-100 d-block" (clicked)="router.navigate(['/auth/login'])">
          </app-button>
        </div>
      </div>
    </div>
  }
</div>
